import { combineReducers } from 'redux';
import { FETCH_ZONE_SUCCESS } from '../actions/zone';
import {
  PLACE_POINT,
  DISPLAY_POINT,
  DISPLAY_ADD,
  HIDE_POINT,
  HIDE_ADD,
  CREATE_POINT,
  CREATE_POINT_SUCCESS,
  CREATE_POINT_ERROR,
  SAVE_POINT,
  DELETE_POINT,
} from '../actions/points';
import { pointId } from './point';
import { Map } from 'immutable';
import keyBy from 'lodash.keyby';

const pointsToMap = (points, filterFunc) => {
  const filtered = points.filter(filterFunc).map(p => ({
    ...p,
    uid: pointId(p),
  }));

  return Map(keyBy(filtered, 'uid'));
};

const pinned = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_ZONE_SUCCESS:
      return pointsToMap(action.points, p => p.coordinate !== null);
    case PLACE_POINT:
      return state.set(pointId(action.point), action.point);
    case SAVE_POINT:
      const id = pointId(action.point);
      return state.has(id) ? state.set(id, action.point) : state;
    case DELETE_POINT:
      return state.remove(pointId(action.point));
    default:
      return state;
  }
};

const unpinned = (state = Map(), action) => {
  switch (action.type) {
    case FETCH_ZONE_SUCCESS:
      return pointsToMap(action.points, p => p.coordinate === null);
    case PLACE_POINT:
      return state.remove(pointId(action.point));
    case CREATE_POINT_SUCCESS:
      return state.set(pointId(action.point), action.point);
    case SAVE_POINT:
      const id = pointId(action.point);
      return state.has(id) ? state.set(id, action.point) : state;
    case DELETE_POINT:
      return state.remove(pointId(action.point));
    default:
      return state;
  }
};

const displayed = (state = null, action) => {
  switch (action.type) {
    case DISPLAY_POINT:
      return action.point;
    case SAVE_POINT:
    case DELETE_POINT:
    case HIDE_POINT:
      return null;
    default:
      return state;
  }
};

const adding = (state = false, action) => {
  switch (action.type) {
    case DISPLAY_ADD:
      return true;
    case CREATE_POINT_SUCCESS:
    case HIDE_ADD:
      return false;
    default:
      return state;
  }
};

const creating = (state = false, action) => {
  switch (action.type) {
    case CREATE_POINT:
      return true;
    case CREATE_POINT_SUCCESS:
    case CREATE_POINT_ERROR:
      return false;
    default:
      return state;
  }
};

const error = (state = null, action) => {
  switch (action.type) {
    case CREATE_POINT_ERROR:
      return action.error;
    case DISPLAY_ADD:
    case HIDE_ADD:
      return null;
    default:
      return state;
  }
};

export default combineReducers({
  pinned,
  unpinned,
  displayed,
  adding,
  creating,
  error,
});

export const getPinnedPoints = state => state.plan.points.pinned.toArray();
export const getUnpinnedPoints = state =>
  state.plan.points.unpinned.sortBy(p => p.number).toArray();
export const getDisplayedPoint = state => state.plan.points.displayed;
export const getIsAddingPoint = state => state.plan.points.adding;
export const getIsCreatingPoint = state => state.plan.points.creating;
export const getCreateError = state => state.plan.points.error;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/zones/plan/reducers/points.js